/**
 * Nome de modelo do WhatsApp no formato que a Meta aceita: minúsculas,
 * números e `_`. A Meta aceita até 512 caracteres, mas `templates.name` é
 * varchar(200) — o teto é o nosso, senão o INSERT estoura com erro 500. Fora disso a Meta recusa o envio
 * ("O nome do modelo de mensagem só pode ter letras minúsculas e
 * sublinhados") — e o cliente só descobre depois de montar o modelo inteiro.
 *
 * "Promoção Curso-Avançado 2026!" → "promocao_curso_avancado_2026".
 */
export const NOME_DE_MODELO_MAX = 200;

export function normalizarNomeDoModelo(bruto: string): string {
  return bruto
    .normalize("NFD")
    .replace(/\p{M}/gu, "") // acentos que o NFD separou da letra
    .toLowerCase()
    .replace(/[^a-z0-9_]+/g, "_")
    .replace(/_+/g, "_")
    .replace(/^_+/, "")
    .slice(0, NOME_DE_MODELO_MAX)
    // Depois do corte: ele pode deixar um `_` no fim.
    .replace(/_+$/, "");
}

export function nomeDeModeloValido(nome: string): boolean {
  return nome.length > 0 && nome.length <= NOME_DE_MODELO_MAX && /^[a-z0-9_]+$/.test(nome);
}
